import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";

import {
  guestUserLoginReducer,
  guestUserDetailReducer,
  guestUserInsertReducer,
  guestAllCommentsReducer,
  guestTodayCommentsReducer,
  guestPastCommentsReducer,
} from "./reducers/userReducer";
import {
  AttendedStuentCountReducer,
  eventNameReducer,
  UniversityCountReducer,
} from "./reducers/EventReducer";
import { contactActivityReducer } from "./reducers/contactReducer";
import {
  UniversityListRecReducer,
  UniversityListUpdateReducer,
} from "./reducers/universityReducer";

const reducer = combineReducers({
  guestUserLogin: guestUserLoginReducer,
  guestUserDetail: guestUserDetailReducer,
  guestUserInsert: guestUserInsertReducer,
  guestAllComments: guestAllCommentsReducer,
  guestTodayComments: guestTodayCommentsReducer,
  guestPastComments: guestPastCommentsReducer,
  eventName: eventNameReducer,
  contactActivity: contactActivityReducer,
  UniversityCountReducer,
  AttendedStuentCountReducer,
  UniversityListRecReducer,
  UniversityListUpdateReducer,
});

const userInfoFromStorage = localStorage.getItem("guestInfo")
  ? localStorage.getItem("guestInfo")
  : null;

// const expdtFromStorage = localStorage.getItem('expdt')
//     ? JSON.parse(localStorage.getItem('expdt'))
//     : null

const initialState = {
  guestUserLogin: { userInfo: userInfoFromStorage },
};

const middleware = [thunk];

const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
